import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ThemeService} from '../../../core/services/theme.service';

@Component({
  selector: 'app-theme-toggle-button',
  templateUrl: './theme-toggle-button.component.html',
  imports:[CommonModule]
})
export class ThemeToggleButtonComponent {

  theme$;

  constructor(private themeService: ThemeService) {
    this.theme$ = this.themeService.theme$;
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }
}
